import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getMarkedFavouriteSuccess = (state) => state.markedFavouriteSuccess;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getMarkedFavouriteSuccess,
};
